const MOBILE_SLIDES = 3;
const DEFAULT_SLIDES = 7;

export const getFirstSlideIndex = (
  planificationDates: string[],
  isMobile: boolean,
  selectedDate?: string
) => {
  if (!planificationDates.length) return 0;

  const today = new Date().toISOString().split('T')[0];
  const anchorDate =
    (selectedDate && planificationDates.includes(selectedDate) && selectedDate) ||
    planificationDates.find(d => d === today) ||
    planificationDates.find(d => d > today) ||
    planificationDates[planificationDates.length - 1];

  const startIndex = planificationDates.indexOf(anchorDate);
  const slidesPerGroup = isMobile ? MOBILE_SLIDES : DEFAULT_SLIDES;
  return Math.floor(startIndex / slidesPerGroup) * slidesPerGroup;
};
